import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {ValidationService} from "../../services/validation.service";
import {Conf} from "../../settings/config";
import {AuthServices} from "../../services/auth.service";
import {User} from "../../models/user.model";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {SignupComponent} from "../signup/signup.component";
import {ForgotComponent} from "../forgot/forgot.component";


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {

    public auth_user = new User();
    loginForm: FormGroup;
    error = {
        username: '',
        email: '',
        password: '',
        login: '',
    };

    constructor(private authService: AuthServices,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                private fb: FormBuilder,
                private http: HttpClient,
                public _auth: AuthService) {

        this.loginForm = fb.group({
            'username': [null, Validators.required],
            'password': [null, Validators.required],
        });
    }

    ngOnInit() {

    }

    socialLogin(provider) {
        this._auth.login(provider).subscribe(
            (dataSocial) => {
                console.log(dataSocial)

                this.auth_user.email = dataSocial['email'];
                this.auth_user.name = dataSocial['name'] ? dataSocial['name'] : '';
                this.auth_user.username = dataSocial['email'];
                this.auth_user.image = dataSocial['image'] ? dataSocial['image'] : '';

                this.closePopup();

                this.http.post(Conf.API_URL + '/auth-users/social-login/', {
                    email: dataSocial['email'],
                    provider: dataSocial['provider'],
                    uid: dataSocial['uid'],
                    name: dataSocial['name'] ? dataSocial['name'] : '',
                    social_image: dataSocial['image'] ? dataSocial['image'] : '',
                }).subscribe(
                    data => {
                        console.log(data)
                        this.auth_user.username = data['username'];
                        this.auth_user.id = data['id'];
                        this.auth_user.pk = data['pk'];
                        this.auth_user.token = data['token'];
                        this.authService.setAuth(this.auth_user);
                    },
                    error => {
                        console.log(error);
                    }
                );
            }
        );
    }

    clickLogin() {
        this.loginForm['submitted'] = true;
        if (this.loginForm.valid) {
            this.http.post(Conf.API_URL + '/auth-users/login/', {
                username: this.loginForm.value.username,
                password: this.loginForm.value.password
            }).subscribe(
                data => {
                    this.auth_user.email = data['email'];
                    this.auth_user.name = data['fullName'];
                    this.auth_user.username = data['username'];
                    this.auth_user.id = data['id'];
                    this.auth_user.pk = data['pk'];
                    this.auth_user.token = data['token'];

                    this.authService.setAuth(this.auth_user);
                    this.closePopup();
                },
                error => {
                    this.error.login = "Invalid email or password.";
                }
            );
        }
    }

    closePopup() {
        this.error = {
            username: '',
            email: '',
            password: '',
            login: '',
        };
        this.activeModal.close();
    }

    openForgot() {
        this.closePopup();
        this.modalService.open(ForgotComponent, {size: "sm"});
    }

    openSignup() {
        this.closePopup();
        this.modalService.open(SignupComponent, {size: "sm"});
    }

    get password(): AbstractControl {
        return this.loginForm.get('password');
    }

    get username(): AbstractControl {
        return this.loginForm.get('username');
    }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/dialogs/login/login.component.ts